import React from "react";
import moment from 'moment';
import context from "../../lib/context.js";
import { browserHistory } from "react-router";
import ajax from "./../../lib/ajax.js";
import Iframe from 'react-iframe';
import Paginator from "./../shared/paginator.jsx";


export default class PaystubGridMobile extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            paystubs: [],
            issueDateSort: 1,
            paymethodSort: 0,
            pageSize: 10

        };
        this.onPaystubDetailClick = this.onPaystubDetailClick.bind(this);
    }
    componentWillReceiveProps(nextProps) {

        this.setState({
            paystubs: nextProps.paystubs,
        });
    }
    onPaystubDetailClick(id) {
        if (this.props.onPaystubDetailClick) this.props.onPaystubDetailClick(id);
    }

    render() {
        let content = [];
        let self = this;
        let paystubs = self.state.paystubs;

        let numPages = (paystubs.length / this.state.pageSize) + (paystubs.length % this.state.pageSize > 0 ? 1 : 0);
        if (paystubs.length === 0) {
            return (
                <div className="col-md-12 ap-paystubgrid-empty">
                    No Pay Statements found !
                </div>
            );
        } else {
            let lower = this.props.startIndex;
            let upper = paystubs.length < this.props.endIndex ? paystubs.length : this.props.endIndex;
            for (let i = lower; i < upper; i++) {
                let p = paystubs[i];
                content.push(
                    <div className="row ap-paystubgrid-detail" key={p.id}>
                        <div className="col-xs-6">
                            <a onClick={() => this.onPaystubDetailClick(p.id)} className="ap-pointer"> {moment(p.issueDate).format('MM/DD/YYYY')}</a>

                        </div>
                        <div className="col-xs-6">
                            {p.checkNumber}
                        </div>
                    </div>
                );
            }
        }
        return (
            <div className="container-fluid">
                <div className="row">
                    <div className="col-md-12 text-center">
                        <i>Cheques ending with "A" are directly deposited</i> <br/><br/>
                    </div>
                    <div className="col-md-12">
                        <div className="container-fluid ap-paystubgrid-header">
                            <div className="row">
                                <div className="col-xs-6">
                                    Issue Date
                                </div>
                                <div className="col-xs-6">
                                    Check Number
                            </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-12">
                        <div className="ap-paystubgrid container-fluid">
                            {content}
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-12">
                        <Paginator total={numPages} range="3" selectedIndex={this.props.currentIndex} onNavigate={this.props.onNavigate} />
                    </div>
                </div>
            </div>
        );
    }
}